import {BuilderContent} from '@builder.io/sdk-react'
import {BANNER_TYPES} from '../builder/blocks/plp/types'

export type PageType = 'product' | 'category' | 'other' | 'unknown'
export interface Icustomer {
    email: string
    isGuest: boolean
    isRegistered: boolean
    c_acLoyaltyTier?: string
}

export interface IBuilderPageReference {
    id: string
    value: {
        data: {
            isSfraPage: boolean
            url: string
        }
    }
}

export type LayoutType = 'scroll' | 'wrap' | 'grid'

export interface IfecthEntriesOptions {
    model?: string | undefined
    apiKey?: string
    limit?: number
    options?: Record<string, any>
    queryKey?: string | string[] | (string | number)[]
    offset?: number
    query?: Record<string, any>
    enabled?: boolean
}

export type CategoryEnrichmentFetchOptions = {
    attributes?: React.HTMLAttributes<HTMLDivElement>
    className?: string
    filterType: BANNER_TYPES | undefined
    list?: Array<Record<string, any>>
    links?: Array<Record<string, any>>
    facets?: Array<{name: string; value: string; display_name?: string}>
    iconSizes?: {
        [key: string]: string | undefined
    }
    layoutType?: LayoutType
}

export interface ICategoryEnrichmentEntry extends BuilderContent {
    data: BuilderContent['data'] & {
        categoryIcon?: string
        categoryShortName?: string
        iconRank?: number
        excludeFromCategoryIconsBanner?: boolean
    }
    meta?: BuilderContent['meta'] & {
        kind?: string
        lastPreviewUrl?: string
    }
}

export type CategoryEnrichment = ICategoryEnrichmentEntry | ICategoryEnrichmentEntry[]

export interface LocalStorageAction {
    action: 'set' | 'get' | 'remove'
}

export interface BuilderImage {
    src: string
    altText?: string
    [key: string]: any
}
